<template>
  <div><i class="msg" @click="toMessage()" v-if="count > 0">{{count}}</i></div>
</template>

<script>
    // import api from '../api/api'
    // import layer from "layui-layer";

    export default {
      name: 'messageTip',
      data: function(){
        return {
            count: 0
        }
      },
      created: function(){
        console.log("messageTip created");
        if(localStorage.getItem("curUserCompany")){
          this.getMessageCnt();
        }
      },
      methods: {
        getMessageCnt: function () {
          let _this = this;
          this.$http.post('/message/0/count', null, function (re) {
            if(re.code == '000000'){
              _this.count = re.data;
            } else {
              console.log('message count error: ' + re.message);
            }
          }, function (re) {
            console.log(re)
          })
        },
        toMessage: function () {
          window.location.href = "message.html";
        }
      }
    }
</script>

<style scoped>
  .msg{
    cursor: pointer;
  }
</style>